<template>
<!-- TODO: 点击二级菜单后一级菜单active-class失效 -->
  <div id="headBar">
    <div id="title">
      <img src="../assets/background.jpg" id="background">
      <img id="headLeft" src="../assets/logo-icon.png">
      <div id="headRight">
        <div id="login">
          <span>{{ year }}年{{ month }}月{{ day }}日</span>
          <a @click="clickLogin">{{ loginText }}</a>
        </div>
        <div id="search-div">
          <input type="text" id="search" placeholder="请输入搜索关键字" v-model="searchWord">
          <img src="../assets/search.png" id="search-button" @click="clickSearch">
        </div>
      </div>
    </div>
    <div id="router">
      <el-dropdown v-for="(item, index) in menus" :key="index" placement="bottom-start"  @visible-change="routeHover">
        <span class="el-dropdown-link">
          <router-link :to="item.route" class="router-go" active-class="active-router" :exact="index === 0 ? true : false">{{ item.name }}
            <i class="el-icon-arrow-down dropdown-icon" v-if="item.sub.length" ></i>
          </router-link>
        </span>
        <!-- 必须要有dropdown插槽（哪怕某项无dropdown），否则el-dropdown组件的triggerElm数据为null，导致报错 Cannot read property 'disabled' of null -->
        <!-- WRONG  <el-dropdown-menu slot="dropdown" v-if="xxxxxxx"> -->
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="(sub, subIndex) in item.sub" :key="subIndex">
            <router-link :to="sub.route" class="sub-router">{{ sub.name }}</router-link>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "headBar",
  data() {
    return {
      year: "",
      month: "",
      day: "",
      searchWord: "",
      menus: [
        {
          name: "首页",
          route: { name: "index" },
          sub: []
        },
        {
          name: "中心概况",
          route: { name: "introduce" },
          sub: [
            { name: "中心简介", route: { name: "itroIndex" } },
            { name: "组织架构", route: { name: "orgStrut" } },
            { name: "研究团队", route: { name: "team" } },
            { name: "科学研究", route: { name: "direction" } }
          ]
        },
        {
          name: "学术交流",
          route: { name: "academic" },
          sub: [
            { name: "研究动态", route: { name: "trends" } },
            { name: "观点摘要", route: { name: "opinion" } }
          ]
        },
        {
          name: "研究成果",
          route: { name: "studyResult" },
          sub: [
            { name: "出版著作", route: { name: "publications" } },
            { name: "学术论文", route: { name: "academicPaper" } },
            { name: "研究报告", route: { name: "researchReport" } },
            { name: "成果应用", route: { name: "achievementApply" } }
          ]
        },
        {
          name: "应急课堂",
          route: { name: "emrClass" },
          sub: [
            { name: "应急常识", route: { path: "/emrClass/knowledge" } },
            { name: "在线微课", route: { path: "/emrClass/onlineClass" } },
          ]
        },
        {
          name: "应急管理专家库",
          route: { name: "experts" },
          sub: []
        },
        {
          name: "学习资料与案例库",
          route: "/dataAndCases",
          sub: [
            { name: "应急法律法规", route: { path: "/dataAndCases/laws" } },
            { name: "应急管理案例", route: { path: "/dataAndCases/cases" } },
            { name: "应急管理论文", route: { path: "/dataAndCases/papers" } }
          ]
        }
      ]
    };
  },
  computed: {
    loginText() {
      return localStorage.Authorization ? '[退出登录]' : '登录'
    }
  },
  methods: {
    routeHover(isShowing) {
      const elHovering = document.querySelector(".router-go:hover");
      const elHovered = document.querySelector(".route-hover");
      if (isShowing && elHovering) {
        elHovering.classList.add("route-hover");
      } else if (elHovered) {
        elHovered.classList.remove("route-hover");
      }
    },
    clickSearch() {
      this.$router.push({ name: "search", query: { word: this.searchWord } });
      this.searchWord = "";
    },
    clickLogin() {
      if (localStorage.Authorization) {
        // 已登录
        localStorage.setItem('Authorization', '')
        this.$router.go(0)
      } else {
        this.$store.commit('changeLoginButton')
      }
    },
    async getBJTime() {
      const time = (await axios.get("http://quan.suning.com/getSysTime.do"))
        .data.sysTime1;
      return {
        year: time.substr(0, 4),
        month: time.substr(4, 2),
        day: time.substr(6, 2),
        hour: time.substr(8, 2),
        min: time.substr(10, 2),
        sec: time.substr(12, 2)
      };
    }
  },
  async created() {
    const time = await this.getBJTime();
    this.year = time.year;
    this.month = time.month;
    this.day = time.day;
  }
};
</script>
<style lang="scss">
ul.el-dropdown-menu {
  margin: 0 !important;
  background-color: #0987d1;
  border: none;
  border-radius: 0;
  // 下拉列表为空时避免出现弹窗（默认有上下padding）
  padding: 0;
  padding-right: 80px;
  .el-dropdown-menu__item {
    font-size: 24px;
    margin: 20px 0;
  }
}
.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: transparent !important;
}
div.popper__arrow {
  display: none !important;
}
</style>

<style lang="scss" scoped>
#headBar {
  width: 100%;
}
#background {
  height: 130px;
  width: 100%;
}
#title {
  position: relative;
  display: flex;
  align-items: center;
}
#headLeft {
  position: absolute;
  left: 200px;
  height: 50%;
}
#headRight {
  position: absolute;
  font-size: 18px;
  right: 150px;
  display: flex;
  flex-direction: column;
}
#login {
  display: flex;
  width: 90%;
  justify-content: space-between;
  margin-bottom: 7px;
  a {
    color: blue;
    cursor: pointer;
    opacity: 0.8;
    &:hover {
      opacity: 1;
    }
  }
}
#search-div {
  display: flex;
}
#search {
  display: inline-block;
  padding: 5px 15px;
  height: 22px;
  width: 200px;
  background: inherit;
  background-color: #ffffff;
  border: none;
  outline: none;
  border-bottom-left-radius: 3px;
  border-top-left-radius: 3px;
  transition: box-shadow 0.2s;
}
#search::placeholder {
  color: #939394;
}
#search:focus {
  box-shadow: 0px 0px 10px #bebebe;
}
#search-button {
  height: 32px;
  background: white;
  cursor: pointer;
}
#router {
  padding-left: 10%;
  padding-right: 10%;
  background-color: #005da2;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  @media screen and (max-width: 1268px) {
    padding: 0 2%;
  }
}
.router-go {
  min-width: 10%;
  display: inline-block;
  padding: 0 20px;
  text-align: center;
  line-height: 56px;
  height: 56px;
  font-size: 24px;
  color: white;
  text-decoration: none;
  white-space: nowrap;
  @media screen and (max-width: 1268px) {
    font-size: 22px;
    min-width: 9%;
  }
  &:hover {
    background-color: #0087d3;
  }
  .dropdown-icon {
    font-size: 16px;
  }
}
.sub-router {
  color: #333;
  &:hover {
    color: #fff;
  }
}
.active-router,
.route-hover {
  background-color: #0087d3;
}
</style>